import { render } from "./ItemDeletionNoticeModal.vue?vue&type=template&id=358cc78f"
import script from "./ItemDeletionNoticeModal.vue?vue&type=script&lang=js"
export * from "./ItemDeletionNoticeModal.vue?vue&type=script&lang=js"

import "./ItemDeletionNoticeModal.vue?vue&type=style&index=0&id=358cc78f&lang=less"

import exportComponent from "C:\\REPOS\\pos-web-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__